<modal *ngIf="showModal" [show]="showModal" (onClose)="onClose()">
  <div class="wrapper text-center">
    <h3 class="modal-title text-primary" i18n="@@vipModal.title">You are now a VIP user</h3>
    <div class="img">
      <img src="assets/images/icons/vip-modal.svg" alt="">
    </div>
    <p class="text-gray text-center text-bold" i18n="@@vipModal.subtitle">Congratulations!</p>
    <p class="text-sm" i18n="@@vipModal.description1">You have been rewarded the VIP status based on your activity on our platform. We hope you enjoy your new VIP rates on our Pro trading platform.</p>
    <p class="text-sm" i18n="@@vipModal.description2">Thank you for being a loyal and valued user.</p>
    <div class="p-2"></div>
    <div class="row g-0">
      <a routerLink="/page/fees" class="col btn btn-outline p-3" i18n="@@vipModal.showFeesButton">Check Rates</a>
      <div class="col-auto p-2"></div>
      <button class="col btn btn-primary p-2" (click)="onClose()" i18n="@@vipModal.continueButton">Continue</button>
    </div>
  </div>
</modal>